<script>
import {
  CollectionCardElementMixin,
} from "%/dynamic-component-editor/standard-components/base-collection-card/collection-card-element-mixin";
import { useGeneralStore } from "%/dynamic-component-editor/stores/general-store";
import ActionCountElement
  from "%/dynamic-component-editor/standard-elements/action-element/ActionCountElement.vue";
import DisplayValue from "%/dynamic-component-editor/options/display-value";

export default {
  name: "CollectionItemCount",
  elementPanelSettings: {
    displayName: "Collection Item Count",
    displayIcon: "number",
    elementType: "element",
    elementGroup: "collectionElements",
  },
  extends: ActionCountElement,
  mixins: [CollectionCardElementMixin],
  computed: {
    myValue() {
      if (this.getOptionValue(DisplayValue) === "hide") {
        return "";
      }
      const count = Number(this.entity.itemCount) || 0;
      return count === 1 ? "1 Item" : `${count} Items`;
    },
    shouldShowAction() {
      return Boolean(this.myValue || this.myIcon);
    },
  },
  methods: {
    handleClick() {
      window.location.href = useGeneralStore().getRelativeHref(`/collection-items/${this.entity.collectionId}`);
    },
  },
};
</script>
